import { useEffect } from 'react';
import AuditHero from './components/AuditHero';
import AuditProblem from './components/AuditProblem';
import AuditSolution from './components/AuditSolution';
import AuditProcess from './components/AuditProcess';
import AuditLeadMagnet from './components/AuditLeadMagnet';
import AuditFinalCTA from './components/AuditFinalCTA';
import Footer from '../landing-page/components/Footer';
import { useSEO, getWebPageSchema, getOrganizationSchema } from '../../utils/seo';

export default function AuditLandingPage() {
  useSEO({
    title: 'Аудит сайта по 208 пунктам | Профессиональный маркетинговый аудит — 3000 руб',
    description: 'Экспертный аудит вашей посадочной страницы веб-сайта по 208 пунктам. PDF-отчёт с картой исправлений, конкурентная разведка, анализ UX и оффера. Срок 2–3 дня, цена 3000 ₽.',
    keywords: 'аудит сайта, маркетинговый аудит, аудит посадочной страницы, увеличение конверсии, юзабилити анализ',
    canonical: '/audit-landing-page',
    schema: {
      '@context': 'https://schema.org',
      '@graph': [
        getOrganizationSchema(),
        getWebPageSchema(
          'Экспертный аудит посадочной страницы по 208 пунктам',
          'Профессиональный маркетинговый аудит вашего сайта с PDF-отчётом и картой исправлений.',
          'SITE_URL/audit-landing-page'
        ),
      ],
    },
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <AuditHero />
      <AuditProblem />
      <AuditSolution />
      <AuditProcess />
      <AuditLeadMagnet />
      <AuditFinalCTA />
      <Footer />
    </div>
  );
}
